import { __decorate } from "tslib";
import { Misc, DebounceHelper } from '@singularsystems/neo-core';
import { reaction } from 'mobx';
import { injectable } from 'inversify';
var AutoRunnerFactory = /** @class */ (function () {
    function AutoRunnerFactory() {
    }
    AutoRunnerFactory.prototype.create = function (model, callback, options) {
        return new AutoRunner(model, callback, options);
    };
    AutoRunnerFactory = __decorate([
        injectable()
    ], AutoRunnerFactory);
    return AutoRunnerFactory;
}());
export { AutoRunnerFactory };
var AutoRunner = /** @class */ (function () {
    function AutoRunner(model, callback, options) {
        var _this = this;
        this.isPaused = false;
        this.propertyMap = {};
        this.options = options !== null && options !== void 0 ? options : {};
        this.disposerDelayed = reaction(function () { return _this.accessAllValues(model, true, new Map(), ""); }, function () { var _a; return _this.runCallback(model, callback, (_a = _this.options.delayMs) !== null && _a !== void 0 ? _a : 500); });
        this.disposerImmediate = reaction(function () { return _this.accessAllValues(model, false, new Map(), ""); }, function () { return _this.runCallback(model, callback, 0); });
    }
    Object.defineProperty(AutoRunner.prototype, "hasPending", {
        get: function () {
            return DebounceHelper.hasPending(this);
        },
        enumerable: false,
        configurable: true
    });
    AutoRunner.prototype.cancelPending = function () {
        if (DebounceHelper.hasPending(this)) {
            DebounceHelper.cancelPending(this);
            return true;
        }
        return false;
    };
    AutoRunner.prototype.fireImmediate = function () {
        DebounceHelper.executeImmediate(this);
    };
    AutoRunner.prototype.dispose = function () {
        this.disposerDelayed();
        this.disposerImmediate();
    };
    AutoRunner.prototype.runCallback = function (model, callback, delay) {
        var _this = this;
        if (!this.isPaused) {
            DebounceHelper.debounce(this, function () {
                _this.isPaused = true;
                try {
                    callback(model);
                }
                finally {
                    _this.isPaused = false;
                }
            }, delay);
        }
    };
    /**
     * Access all the property values of a model including it's value objects properties.
     * @param instance Instance to access.
     * @param delayed True if only delayed properties should be accessed. A delayed property is one where the user
     * types in the value over a short period of time. E.g. numeric input or text input.
     */
    AutoRunner.prototype.accessAllValues = function (instance, delayed, trackedInstances, path) {
        var _a;
        if (instance && !trackedInstances.has(instance)) {
            trackedInstances.set(instance, true);
            var info = instance.constructor.neo;
            var filterProperties = path === "" ? this.options.rootProperties : undefined;
            for (var _i = 0, _b = info.properties; _i < _b.length; _i++) {
                var propertyInfo = _b[_i];
                if (!propertyInfo.noTrack && instance.meta[propertyInfo.propertyName] && (!filterProperties || filterProperties.indexOf(propertyInfo.propertyName) >= 0)) {
                    if (propertyInfo.relationType === Misc.RelationType.None) {
                        var key = path + propertyInfo.propertyName;
                        var useDelay = this.propertyMap[key];
                        if (useDelay === undefined) {
                            // This needs to be calculated once, otherwise null -> string value changes cause properties to no longer be tracked.
                            useDelay = (_a = propertyInfo.debounce) !== null && _a !== void 0 ? _a : ([Misc.DataType.Int, Misc.DataType.Float].indexOf(propertyInfo.propertyType) >= 0 ||
                                (typeof instance.meta[propertyInfo.propertyName].peek === "string"));
                            this.propertyMap[key] = useDelay;
                        }
                        if (useDelay === delayed) {
                            //@ts-ignore
                            void instance[propertyInfo.propertyName];
                        }
                    }
                    else if (propertyInfo.relationType === Misc.RelationType.ValueObject ||
                        (propertyInfo.relationType === Misc.RelationType.ChildObject && this.options.includeChildObjects)) {
                        //@ts-ignore
                        this.accessAllValues(instance[propertyInfo.propertyName], delayed, trackedInstances, path + propertyInfo.propertyName + ".");
                    }
                    else if (propertyInfo.relationType === Misc.RelationType.ChildList && this.options.includeChildLists) {
                        var index = 0;
                        //@ts-ignore
                        for (var _c = 0, _d = instance[propertyInfo.propertyName]; _c < _d.length; _c++) {
                            var child = _d[_c];
                            this.accessAllValues(child, delayed, trackedInstances, "".concat(path).concat(propertyInfo.propertyName, "[").concat(index++, "]."));
                        }
                    }
                }
            }
        }
        return {};
    };
    return AutoRunner;
}());
